<template>
  <div
    :style="{
      height: showHeight,
      overflowY: 'auto',
      overflowX: 'hidden',
    }"
  >
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      class="mr-2"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item :label="'库位编号'" prop="locationNo">
            <el-input
              size="small"
              :disabled="disabledForm"
              clearable
              v-model="formData.locationNo"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item :label="'库位描述'" prop="locationDescription">
            <el-input
              size="small"
              clearable
              v-model="formData.locationDescription"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item :label="'上级描述'" prop="parentName">
            <el-input
              size="small"
              disabled
              clearable
              v-model="formData.parentName"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="'是否末级'" prop="isLast">
            <br />
            <el-select
              v-model="formData.isLast"
              :disabled="disabledLast"
              size="small"
              style="width:100%"
            >
              <el-option :label="'是'" value="Y" />
              <el-option :label="'否'" value="N" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'层级'" prop="classLevel">
            <el-input
              size="small"
              disabled
              clearable
              v-model="formData.classLevel"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col>
          <el-form-item label="负责机构" prop="orgCode">
            <org-cascader
              :valueString.sync="formData.orgCodeList"
              :lastValue.sync="formData.orgCode"
              placeholder="请选择负责机构"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="'创建人'" prop="createByName">
            <el-input
              size="small"
              disabled
              clearable
              v-model="formData.createByName"
              placeholder="系统生成"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'创建时间'" prop="createTime">
            <el-date-picker
              disabled
              size="small"
              style="width:100%"
              v-model="formData.createTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="系统生成"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="'修改人'" prop="modifyByName">
            <el-input
              size="small"
              disabled
              clearable
              v-model="formData.modifyByName"
              placeholder="系统生成"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'修改时间'" prop="modifyTime">
            <el-date-picker
              disabled
              style="width:100%"
              size="small"
              v-model="formData.modifyTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="系统生成"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button v-if="!disabled" type="primary" size="small" @click="save()">{{
        '保存'
      }}</el-button>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import store from '../../store'
export default {
  mixins: [],
  props: {},
  data() {
    return {
      disabledForm: true,
      disabledLast: true,
      isEditMode: true,
      disabled: false,
      formData: {
        locationNo: '',
        locationDescription: '',
        createByName: '',
        createTime: '',
        locationCode: '',
        modifyByName: '',
        modifyTime: '',
        parentLocationCode: '',
        classLevel: '',
        isLast: '',
        orgCodeList: '',
        orgCode: '',
        locationNoPath: '',
      },
      rules: {
        locationNo: [
          {
            required: true,
            message: '请输入库位编号',
            trigger: 'blur',
          },
        ],
      },
      showHeight: '500px',
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  watch: {
    selected() {
      this.getData()
    },
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.showHeight = window.innerHeight - 234 + 'px'
    },
    getData() {
      this.disabled = true
      if (!this.selected || !this.selected.locationCode) return
      this.$api
        .masterLocationDetailApi({
          locationCode: this.selected.locationCode,
        })
        .then((res) => {
          if (res.body) {
            this.formData = res.body
          }
        })
      this.$emit('updateDisabled')
    },
    openEdit() {
      if (this.selected) {
        this.getData()
        this.disabled = false
        this.disabledLast = true
        this.isEditMode = true
        this.disabledForm = true
      } else {
        this.$message.warning('请选择库位')
      }
    },
    openAdd() {
      if (!this.selected) {
        this.$message.warning('请选择库位')
        return
      }
      if (this.selected.isLast == 'Y') {
        this.$message.warning('注意已经是末级！')
        return
      }
      if (this.selected.locationStatus == 'N') {
        this.$message.warning('请选择有效库位')
        return
      }
      if (this.selected.classLevel >= 1) {
        this.formData.locationNo = ''
        this.formData.locationDescription = ''
        this.formData.createByName = ''
        this.formData.createTime = ''
        this.formData.locationCode = ''
        this.formData.modifyByName = ''
        this.formData.modifyTime = ''
        this.formData.orgCodeList = ''
        this.formData.orgCode = ''
        this.formData.locationNoPath = this.selected.locationNoPath
        this.formData.parentLocationCode = this.selected.locationCode
        this.formData.classLevel = parseInt(this.selected.classLevel) + 1 //1
        this.formData.isLast = 'Y'
        this.formData.parentName = this.selected.locationDescription
        this.disabled = false
        this.disabledForm = false
        this.disabledLast = this.selected.classLevel == 0
        this.isEditMode = false
      }
    },
    openAddTop() {
      this.formData.locationNo = ''
      this.formData.locationDescription = ''
      this.formData.createByName = ''
      this.formData.createTime = ''
      this.formData.locationCode = ''
      this.formData.modifyByName = ''
      this.formData.modifyTime = ''
      this.formData.parentLocationCode = ''
      this.formData.locationNoPath = ''
      this.formData.classLevel = 1 //1
      this.formData.isLast = 'N'
      this.formData.orgCodeList = ''
      this.formData.orgCode = ''
      this.disabled = false
      this.disabledForm = false
      this.disabledLast = this.formData.classLevel == 0
      this.isEditMode = false
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])

      if (!result) {
        return
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterLocationSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          if (this.isEditMode)
            // //更新状态
            this.selected.isLast = this.formData.isLast
          this.onCurrentTreeChange()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    openDel() {
      if (!this.selected || !this.selected.locationCode) {
        this.$message.warning('请选择一个库位')
        return
      }

      if (this.selected.locationStatus == 'N') {
        this.$message.warning('请选择有效库位')
        return
      }

      this.$confirm('确认要删除该记录吗？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        this.$api
          .masterLocationDelApi({ locationCode: this.selected.locationCode })
          .then((res) => {
            loadingInstance.close()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.formData.locationNo = ''
            this.formData.locationDescription = ''
            this.formData.createByName = ''
            this.formData.createTime = ''
            this.formData.locationCode = ''
            this.formData.modifyByName = ''
            this.formData.modifyTime = ''
            this.formData.parentLocationCode = ''
            this.formData.locationNoPath = ''
            this.formData.classLevel = ''
            this.formData.isLast = ''
            this.formData.orgCodeList = ''
            this.formData.orgCode = ''
            // this.selected = {}
            this.onCurrentTreeChange()
          })
          .catch(() => {
            loadingInstance.close()
          })
      })
    },
    onCurrentTreeChange() {
      this.$eventBus.$emit('selectTreeList')
    },
  },
}
</script>
